<template>
  <div id="app">
    <transition name="fade" mode="out-in">
        <router-view v-if="isRouterAlive" ref='Navview'></router-view>
    </transition>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape"
      :show-close="showClose"
      center>
      <div class="upgradee">
        <el-progress
          status="success"
          :text-inside="true"
          :stroke-width="20"
          :percentage="percentage"
          :width="strokeWidth"
          :show-text="true"
        ></el-progress>
      </div>
      <div v-html="content" class="upgrade-content">
      </div>
    </el-dialog>
    <canvas v-show="false" id="base64CanvasRegion" width="460" height="400"/>
    <el-dialog
    :visible="loginModelStatus"
    top="30vh"
    custom-class="login-modal"
    @close="closeLoginModel"

    >
      <div class="login-msg-title" slot="title">
        <img src="//storage.360buyimg.com/jdcp-web/Image/message3.png" alt="">
        <div class="title">{{ $t('loginFailure') }}</div>
      </div>
      <div class="login-content">
        <div class="loginMessageContentDesc1">{{ $t('loginFailureTips') }}</div>
        <div class="loginMessageContentDesc2">
          <img src="//storage.360buyimg.com/jdcp-web/Image/message1.png" alt="">
          {{ $t('loginStep1') }}
          <span class="link" @click="jumpLogin">
            <u> {{ $t('loginStep1-1') }}</u>
          </span>
          {{ $t('loginStep1-2') }}
        </div>
        <div class="loginMessageContentDesc3">
          <img src="//storage.360buyimg.com/jdcp-web/Image/message2.png" alt="">
          {{ $t('loginStep2') }}
        </div>
      </div>
    </el-dialog>
    <!-- <i18nRightMenu></i18nRightMenu> -->
  </div>
</template>
<script>
import getPrefix from '@/api/apiConfig.js'
//import config from '../package.json'
// import topNav from '@/components/topNav'
// import leftNavOfWms from '@/components/leftNavOfWms'
// import leftNavOfSpm from '@/components/leftNavOfSpm'
import { $Vue2Storage, StorageEnum } from '@/api/utils/storage/sessionStorage'
import axios from 'axios'
import { Notification } from 'element-ui'
import { mapGetters } from 'vuex'
import { setCookieTimer } from './api/biz/outbound/OutBoundService';
import Cookies from 'js-cookie'
import { playNotification } from "@/api/utils/audio.js";
import {
  getNoticeToAssignSwitch,
  getExistPickTaskNeedAssign,
} from "@/api/biz/taskAssign/taskAssignService";
import { userInfo } from "./global";
import {getSite} from '@/api/lib/stream/index.js'
import {loadScript, getBtnPermission} from '@/utils/setMethods.js'
import {queryCsatPopupIsRequired, receiveUserCsat , queryNpsPopupIsRequired} from './api/biz/index/indexService'
import LangBox from '@jd/lang-box'
import '@jd/lang-box/lib/theme/index.css'
import {getSysConfigByKey} from '@/api/biz/master/masterService.js'
import {getIsnovaEnv} from '@/api/apiConfig.js'


//let ipcRenderer = require("electron").ipcRenderer;
// let _this = this;
//接收主进程版本更新消息
// ipcRenderer.on("message", (e, arg) => {
//   console.log("ipcRenderer.on('message'), args: arg=" + (arg? JSON.stringify(arg) : ""));
//   if ("update-available" == arg.cmd) {
//     _this.dialogVisible = true;
//   } else if ("download-progress" == arg.cmd) {
//     //更新升级进度
//     /**
//      *message:{
//         bytesPerSecond: 47673
//         delta: 48960
//         percent: 0.11438799862426002
//         total: 42801693
//         transferred: 48960
//       }
//     */
//     let percent = Math.round(parseFloat(arg.message.percent));
//     _this.percentage = percent;
//   }
//   // else if("update-downloaded" == arg.cmd){
//   //   ipcRenderer.send("isUpdateNow");
//   // }
//   else if ("error" == arg.cmd) {
//     _this.dialogVisible = false;
//     _this.$message(_this.$t('updateFail'));
//   }
// });

// ipcRenderer.on("isUpdateNow", () => {
//   ipcRenderer.send("isUpdateNow");
// });

//2秒后开始检测新版本
// let timeOut = window.setTimeout(() => {
//   ipcRenderer.send("checkForUpdate");
// }, 2000);

/*
//间隔1小时检测一次
let interval = window.setInterval(() => {
  ipcRenderer.send("checkForUpdate");
}, 3600000);
*/

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    // topNav,
    // eslint-disable-next-line vue/no-unused-components
    // leftNavOfWms,
    // leftNavOfSpm
    // i18nRightMenu
  },
  computed: mapGetters([
    'loginModelStatus'
  ]),
  data() {
    return {
      title: this.$t('updatingNewVersionTitle'),
      content: this.$t('updatingNewVersionLogContent'),
      message: {
        error: this.$t('errorMsgWhenUpdatingFailed'),
        checking: this.$t('inprogressMsgWhenUpdating'),
        updateAva: this.$t('availableMsgWhenUpdating'),
        updateNotAva: this.$t('unavailableMsgWhenUpdating'),
      },
      dialogVisible: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      showClose: false,
      percentage: 0,
      strokeWidth:200,
      isRouterAlive: true,
      version:'',
      uploadNotificationShow : false,
      buttonStyle: 'padding: 9px 15px;border: 0;width: 100%;background-color: #e6a23c;color: #fff;margin-top: 10px;border-radius:20px;cursor:pointer;',
      storageName :'JD-LIGHT-WMS',
      cookieTimer: null,
      assignNotice:'',
      assignNotificationShow:false,
      i18nFlag:localStorage.getItem('i18nFlag') || 'false',
    };
  },
  provide(){
    return{
      reload: this.reload
    }
  },
  methods: {
      async intAssignNotice() {
        var query = {
          orgNo: Cookies.get('orgNo'),
          distributeNo: Cookies.get('distributeNo'),
          warehouseNo: Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo'),
        };
        let tmpResult = await getNoticeToAssignSwitch(query);
        let assignInfo = tmpResult;
        var switchStatus = assignInfo.switchStatus;
        var queryInterval = assignInfo.queryInterval?assignInfo.queryInterval:1;
        // if (switchStatus) {
        //   this.assignNotice = setInterval(async () => {
        //     let assignReslt = await getExistPickTaskNeedAssign(query);
        //     if (assignReslt) {
        //       if (!this.assignNotificationShow) {
        //         this.assignNotificationShow = true;
        //         this.$notify.warning({
        //           title: this.$t("assignedTitle"),
        //           message: this.$t("assignedDetail"),
        //           showClose: true,
        //           duration: 0,
        //           position: 'bottom-right',
        //           customClass:'notificationClass'
        //         })
        //         playNotification();
        //       } else {
        //         playNotification();
        //       }
        //     } else {
        //       if (this.assignNotificationShow) {
        //         this.assignNotificationShow = false;
        //       }
        //     }
        //   }, 1000 * 60 * queryInterval);
        // }
      },
    clearAssignNotice() {
      window.clearInterval(this.assignNotice);
    },
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true;
      })
    },
    getVersion(){
      let oldVersion= $Vue2Storage.get(StorageEnum.Version,this.storageName)
      console.info('当前版本：',oldVersion);
      axios.get(`../static/version.json?_=${Math.random()}`).then((response) => { // 访问前端服务器获取版本号
        console.info('请求：',response);
        let newVersion =response.data.version;
        if (newVersion && (!oldVersion || oldVersion === 'undefined')) {
          $Vue2Storage.set(StorageEnum.Version,this.storageName,newVersion)
        }else if (newVersion && oldVersion && newVersion !== oldVersion) {
          if(!this.uploadNotificationShow){
            this.openNotification()
          }
        }
      }).catch((err) => {
        console.error('checkVersion', err);
      });
    },
    getHkIncreaseVersion(){
      if(this.uploadNotificationShow) return
      try {
        axios.get(`/index/checkVersion?v=${window.APP_VERSION}`)
          .then((response) => {
            if(response && response.data){
              let res = response.data
              if(res.code !== 200 ){
                this.openNotification()
              }else if(res.code === 200){
                let data = res.data || {}
                if(data.isBackVersion){
                  this.openNotification()
                }
              }
            }
          }).catch((err) => {
            console.error('checkVersion', err);
          });
      } catch (error) {
        console.log(error)
      }
    },
    openNotification () {
      this.uploadNotificationShow = true;
      Notification.warning({
        position: 'bottom-right',
        title: this.$t('newVersionTitle'),
        dangerouslyUseHTMLString: true,
        duration: 0,
        customClass: 'newVersionNotificationClass',
        showClose: false,
        message: `<div>
      <p>${this.$t('newVersionReminderTip')}</p>
      <button style="${this.buttonStyle}">${this.$t('refreshNow')}</button>
    </div>`,
        onClick: () => this.onRefresh(),
      });
    },
    onRefresh  ()  {
      window.location.href = '/'
    },
    jumpLogin() {
      window.open('https://pulsar-login.jd.com/login.html?ReturnUrl=' + encodeURIComponent(window.location.href))
    },
    closeLoginModel() {
      window.mainVm.$store.commit('LOGIN_MODEL', false)
    },
    setCookieTimerHandler() {
      const isB = Cookies.get('lwms.lt') == 'b'
      if (!isB) {
        return
      }
      let that = this
      let runAnyway = false
      const userName = Cookies.get('userName')
      const warehouseNo = Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo')
      clearInterval(that.cookieTimer)
      if (warehouseNo && userName) {
        if (!localStorage.getItem(`lastRenewalTime_${warehouseNo}_${userName}`)) {
          localStorage.setItem(`lastRenewalTime_${warehouseNo}_${userName}`, Date.now())
          runAnyway = true
        }
        if (!localStorage.getItem(`lastInvokeTime_${warehouseNo}_${userName}`)) {
          localStorage.setItem(`lastInvokeTime_${warehouseNo}_${userName}`, Date.now() + 1)
          runAnyway = true
        }
        if (runAnyway) {
          setCookieTimer()
        }
      }
      this.cookieTimer = setInterval(() => {
        const userName = Cookies.get('userName')
        const warehouseNo = Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo')
        if (!warehouseNo || !userName) {
          console.log('setCookieTimerHandler user logged out')
          return
        }
        if (!localStorage.getItem(`lastRenewalTime_${warehouseNo}_${userName}`)) {
          localStorage.setItem(`lastRenewalTime_${warehouseNo}_${userName}`, Date.now())
          console.log(`setCookieTimerHandler lastRenewalTime_${warehouseNo}_${userName} has been cleared`)
        }
        if (!localStorage.getItem(`lastInvokeTime_${warehouseNo}_${userName}`)) {
          localStorage.setItem(`lastInvokeTime_${warehouseNo}_${userName}`, Date.now() + 1)
          console.log(`setCookieTimerHandler lastInvokeTime_${warehouseNo}_${userName} has been cleared`)
        }
        const timeDiff = Number(localStorage.getItem(`lastInvokeTime_${warehouseNo}_${userName}`)) - Number(localStorage.getItem(`lastRenewalTime_${warehouseNo}_${userName}`))
        if (timeDiff > 0) { // && timeDiff <= 1000 * 60 * 5
          console.log(`setCookieTimerHandler renewal success, diff timestamp: ${timeDiff} ms, diff minute: ${timeDiff / 60000} min`)
          setCookieTimer()
          return
        }
        const timestamp = Date.now() - Number(localStorage.getItem(`lastInvokeTime_${warehouseNo}_${userName}`))
        console.log(`setCookieTimerHandler not meeting renewal condition, diff timestamp: ${timeDiff} ms, diff minute: ${timeDiff / 60000} min. ${timestamp} ms, ${timestamp / 60000} min have passed since the last invoking`)
      }, 1000 * 60 * 5)
    },
    getFeedBackDOMAndRemove(){
      const feedbackDom=document.getElementById('__feedback_container')
      if(feedbackDom){
        const parentElement = feedbackDom.parentNode;
        parentElement&&parentElement.removeChild(feedbackDom);
      }
    },
    async initLangBox(){
      try {
        this.langBox = new LangBox({
          appId: 'iWMS',
          lang: 'zh',
          cookieKey: 'jd.erp.lang',
          userId: 'songning9',
          debug: true,
          dataBaseName:'iwmsDataBase',
          pullOnlineDatabase:true,
          site:getSite(),
          env:['SG','EU','GG'].includes(window.APP_ENV)?'prod':'dev'
        })
        window.langBoxObj = this.langBox
      } catch (error) {
        console.log("🚀 ~ initLangBox ~ error:", error)
      }
    },
    initSCSDK() {
      window.system = 'iWMS'
      window.customerCode = userInfo.warehouseNo // 仓id
      window.customerName = userInfo.warehouseName // 仓名称
      window.pin = Cookies.get('pin')|| ''
      window.site = getSite()
      console.log(getPrefix())
      console.log(window.site, '=====xxx======', userInfo)
      this.loadScriptPromise('https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-053-01-imp/iwms-sc-sdk-0918.js').then(() => {
      window.configUrlFilters && window.configUrlFilters({
          exact: [
            `https:${getPrefix().api}/spm/getUserMenuResourceList`, // 精确匹配菜单接口
            `https:${getPrefix().api}/user/info`, // 精确匹配用户信息接口
            `https:${getPrefix().mcsApi}/mcs/service/simpleWebServiceSoap/addLog`,
            `https:${getPrefix().mcsApi}/user/queryCsatPopupIsRequired`,
            `https:${getPrefix().mcsApi}/user/queryNpsPopupIsRequired`,
            'http://localhost:9021/v2/print/'
          ],
          contains: [
            '/ducc/', // 过滤所有公共接口
            '/csat/',
            'https://c.go-mpulse.net',
            'https://s3.ap-malaysia-1.jdcloud-oss.com',
            'https://trial-eum-clienttons-s.akamaihd.net',
            '/servicebillApi/addLog',
            '/weblog/writeRemoteLog',
            '/language/getLanguageByPin',
            '/index/checkVersion',
            '/printCenterApi/globalPrint/printAll',
            '/pulsar-meta/metaDataAddInner',
            '/v2/print',
            `https:${getPrefix().mcsApi}/user/checkSpmResource`,
            '/weblog/writeRemoteLog',
            '../static/version.json'
          ]
        });
      })
    },
    loadScript(url) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      document.body.appendChild(script);
    },
    loadScriptPromise(url){
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script ${url}`));
        document.head.appendChild(script);
      });
    },
    async initPageSpy(){
      await loadScript('//s3.ap-malaysia-1.jdcloud-oss.com/jd-th-053-01-imp/jdl-spy.min.js')
      if(window.JDLSpy){
        const spy = new window.JDLSpy({
          project: 'iWMS',
          title: userInfo.userCode,
          pin: userInfo.userCode,
        })
        spy.init()
        window.jdlSPyObj = spy
      }
    },
    receiveUserCsatHandel(status) {
      receiveUserCsat({
        "systemCode": "iWMS",
        "nodeCode": Cookies.get('login.select.warehouse'),
        "userCode": Cookies.get('userCode'),
        "userName": Cookies.get('userName'),
        "clientType": 1,
        "pageCode":"Index",
        "status": status
      })
    },
    async initAIassistant(){
      try {
        // 如果 localStorage 中还没有 btnPermissions 缓存，说明菜单接口还未返回
        // 此时监听 btnPermissionsReady 事件，等菜单数据写入后再执行
        const btnPermissions = localStorage.getItem('btnPermissions')
        if (!btnPermissions) {
          await new Promise((resolve) => {
            const handler = () => {
              window.removeEventListener('btnPermissionsReady', handler)
              resolve()
            }
            window.addEventListener('btnPermissionsReady', handler)
          })
        }
        const isnovaPermission = getBtnPermission('ISNOVA')

        if(isnovaPermission){
          await loadScript("https://s3.ap-malaysia-1.jdcloud-oss.com/jd-th-053-01-imp/ai-assistant-sdk-prod0630.umd.min.js")
          const sdkOptions={
            env: getIsnovaEnv(),
            from: 'iWMS',
            props: {
              account: userInfo.userCode, //pin/ERP
              type: this.loginType ==='b'?'B':'ERP', // B/ERP
            },
            config:{
              defaultOpenMode: 'bigDialog',
              allowedModes: ['bigDialog']
            },
            langCookieKey: 'jd.erp.lang', // 自定义语言cookie键名
            payload: {
              systemId: 'iWMS', // 必填：系统ID
              account: userInfo.userCode, // 必填：账号
              type: this.loginType ==='b'?'B':'ERP', // 必填：账号类型
              tenantId: Cookies.get('login.select.tenant'), // 可选：租户ID
              authority: '', // 可选：权限信息
              feature: {
                warehouseNo: userInfo.warehouseNo, // 可选：仓号，WMS系统需要
                warehouseName: userInfo.warehouseName
              }
            }
          }
          const sdk = AIAssistantSDK.init(sdkOptions);
          window.sdkInstance = sdk;
          window.reInitAIAssistantSDK = () => {
            window.sdkInstance = AIAssistantSDK.init(sdkOptions);
          };
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created() {
    const loginType = Cookies.get('lwms.lt')?Cookies.get('lwms.lt'):'b'
    this.loginType= loginType
    this.setCookieTimerHandler()
    // this.initPageSpy()
    this.initLangBox()
    this.initAIassistant()
    if(
      Cookies.get('login.select.warehouse') && Cookies.get('userCode') && Cookies.get('userName') && 
      ['SG','EU','GG','SG_GRAY','EU_GRAY','GG_GRAY'].includes(window.APP_ENV)
    ) {
      queryNpsPopupIsRequired({
        "systemCode": "iWMS",
        "nodeCode": Cookies.get('login.select.warehouse'),
        "userCode": Cookies.get('userCode'),
        "clientType": 1,
        "pageCode":"Index"
      }).then((res) =>{
        const result = JSON.parse(res.resultValue)
        if(result.isRequired) {
          window.JD_CSAT({
              // id: 'root',
              prefix: ['GG','GG_GRAY'].includes(window.APP_ENV) ? '/csat-api':'https://csat.jd.com/',
              systemCode: 'iwms',
              userType: loginType==='erp' ? 1 : 3,
              routerType: 'history',
              language: Cookies.get('jd.erp.lang') || 'en_US',
              headers: {
                  pin: loginType==='erp' ? Cookies.get('userCode') : Cookies.get('pin'),
                  'Lop-Dn': loginType==='erp' ? 'erp.csat.local.com' : 'b.csat.jdl.com',
              },
          }).then(instance => {
            window.__JD_CSAT = instance;
            window.log && window.log('iwms_csat_open', loginType)
          });
        }
      })
    }
  },
  activated() {
    this.setCookieTimerHandler()
  },
  async mounted(){
    // _this = this;
    //生产环境增加版本更新后提示弹窗
    if(process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'pre'){
      this.version = setInterval(() => {
        if(['SG', 'SG_GRAY', 'GG', 'GG_GREY', 'EU', 'EU_GRAY'].includes(window.APP_ENV)){
          this.getHkIncreaseVersion();
        } else {
          this.getVersion();
        }
      }, 1000 * 60 * 3);
    }
    this.getFeedBackDOMAndRemove()
    this.initSCSDK()
  },
  watch:{
    userInfo: {
      async handler(newVal, oldVal) {
        if (Cookies.get('orgNo') && (Cookies.get('login.select.warehouse')||Cookies.get('warehouseNo'))&& Cookies.get('distributeNo')) {
          this.intAssignNotice();
        }
        if (!(Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo'))) {
          return;
        }
        let faceSheetCloudPrintFlag = await getSysConfigByKey('enable_facesheet_cloud_print') == '1';
        let cloudPrintLog = {
          pin: Cookies.get('pin'),
          uuid: window.eid || localStorage.getItem('eid'),
          warehouseNo: Cookies.get('warehouseNo'),
          platformNo: window.localStorage.getItem('strPlatformNo') || window.localStorage.getItem('strPlatformNoNew') || null,
          isUse: null,
          funName: 'iwms_cloud_print',
          time: new Date().getTime(),
        }
        if(faceSheetCloudPrintFlag) {
          // 全仓开启云打印
          cloudPrintLog.platformNo = 'all'
          cloudPrintLog.suPlatformNo = 'all'
          cloudPrintLog.isUse = true
        } else {
          // 检查复核台
          if(window.localStorage.getItem(userInfo.userCode + '_currentCloudPrintFlag') === '1') {
            localStorage.setItem('currentCloudPrintFlag', 1)
          }
          let currentCloudPrintFlag = window.localStorage.getItem('currentCloudPrintFlag') === '1'
          cloudPrintLog.isUse = currentCloudPrintFlag
        }
        setTimeout(() => {
          if(!cloudPrintLog.uuid) {
            return
          }
          window.log && window.log('iwms_fun_log', JSON.stringify(cloudPrintLog))
        }, 8000)
      },
      deep: true,
      immediate: true
    }
  },
  destroyed: function() {
    //ipcRenderer.removeAll(["message", "isUpdateNow"]);
    //window.clearTimeout(timeOut);
    //window.clearInterval(interval);
    this.clearAssignNotice()
    window.clearInterval(this.version);
  }
}
</script>
<style lang="scss">
  html,body{
    height: 100%;
  }
  #app{
    height: 100vh;
    background-color:#F5F5F6;
  }
  .content-box{
    display: flex;
    flex-direction: row;
    position: relative;
    height: calc(100% - 64px);
  }
  .right-content{
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    padding:  0 15px 15px 15px;
    overflow-x: hidden;
    position: relative;
  }
  .view-title{
    font-size: 20px;
    color: #333333;
    font-weight: bold;
    height: 32px;
    display: none;
  }
  .notificationClass{
    .el-notification__title{
      font-size:30px !important
    }
    .el-notification__content{
      font-size:28px !important;
      line-height:32px !important
    }
  }
  .table-header{
    height: 40px!important;
    background: #F5F5F6!important;
    padding: 0!important;
    font-size: 14px;
    color: #868D9F;
    border-right: none!important;
  }
  .table-header:nth-of-type(1){
    border-top-left-radius:8px;
    border-bottom-left-radius:8px
  }
  .table-header:nth-last-of-type(2){
    border-top-right-radius:8px !important;
    border-bottom-right-radius:8px!important;
  }
  .table-header:nth-last-of-type(1){
    border-right:none !important;
  }
  .table-header-small{
    height: 38px!important;
    background: #F5F5F6!important;
    padding: 0!important;
    font-size: 14px;
    color: #868D9F;
    border-right: none!important;
    overflow: inherit!important;
  }
  .expand-table-header{
    height: 40px!important;
    background: rgba(244,246,249,0.8);
    padding: 0!important;
    font-size: 14px;
    color: #868D9F;
    border-right: none!important;
  }
  .expand-table-header:nth-of-type(1){
    border-top-left-radius:8px;
    border-bottom-left-radius:8px
  }
  .expand-table-header:nth-last-of-type(2){
    border-top-right-radius:8px !important;
    border-bottom-right-radius:8px!important;
  }
  .expand-table-header:nth-last-of-type(1){
    border-right:none !important;
  }
  .expand-table-header-small{
    height: 38px!important;
    background: #F5F5F6!important;
    padding: 0!important;
    font-size: 14px;
    color: #868D9F;
    border-right: none!important;
    overflow: inherit!important;
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td:nth-of-type(1){
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td:last-of-type{
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .el-table--border::after, .el-table--group::after, .el-table::before{
    background: #ffffff !important;
  }
  .el-table__fixed-right::before, .el-table__fixed::before{
    background: #ffffff !important;
  }
  .el-table-column--selection .cell{
    padding-left: 14px !important;
  }
  .el-table-column--selection .cell .el-checkbox .el-checkbox__input .el-checkbox__inner{
    border-radius: 4px;
  }
  .el-pagination .el-select .el-input .el-input__inner,
  .el-pagination.is-background .el-pager li:not(.disabled).active,
  .el-pagination__editor.el-input .el-input__inner
  {
    background-color: #ffffff;
    border-radius: 8px !important;
  }
  .el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon{
    margin-left:9px;
  }
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev{
    background: #ffffff !important;
  }
  .el-pagination.is-background .el-pager li {
    background: #ffffff !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #3C6EF0 !important;
  }
  .el-pagination.is-background .el-pager li:hover{
    background-color: #F5F5F6 !important;
    border-radius: 8px;
  }



  .el-table--border{
    border:none !important;
  }
  .el-table--border th > .cell {
          padding: 0 10px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
  }
  .el-table--border th > .cell::before {
            position: absolute;
            top: 0;
            left: -1px;
            bottom: 4px;
            width: 1px;
            // border-right: 1px #e4e5e9 solid;
            content: "";
            min-height: 40px;
  }
  .el-table--border th:first-child > .cell::before {
            display: none;
  }
  .tbody-class{
    height: 40px;
    padding: 0!important;
    font-size: 14px;
    color: #525765;
    border-right: none!important;
  }
  table{
    border-spacing: 0;
  }
  .el-table {
    maxHeight:"900px"
  }
  .el-table th div{
    /*line-height: 1!important;*/
    white-space: nowrap;
  }
  .cell{
    position: static!important;
  }
  .el-table .cell, .el-table th div,.el-table__header-wrapper,.el-table{
    // overflow: inherit!important;
    // white-space: pre-line!important;
    word-wrap: break-word;
    word-break: normal !important;
    border-radius: 8px;
  }
  .el-table{
    overflow: auto!important;
  }
  .disableTxt{
    color: #A5A5A5!important;
  }
  .el-input__prefix{
    left: 80%!important;
    right: 0!important;
  }
  .el-input--prefix .el-input__inner{
    padding-left: 15px!important;
    padding-right: 0!important;
  }
  .small-date{
    input{
      height: 24px!important;
    }
    .el-input__icon{
      line-height: 24px!important;
    }
  }
  .el-dialog__header{
    border-bottom: 1px solid #f5f5f5;
    padding: 10px!important;
    font-weight: bold;
    color: #333333;
  }
  .el-dialog__title{
    font-size: 16px!important;
  }
  .el-dialog__body{
    border-bottom: 1px solid #f5f5f5;
    padding: 10px!important;
  }
  .el-dialog__headerbtn{
    top: 13px!important;
  }
  .el-dialog__footer{
    padding: 10px!important;
  }
  /*表单样式*/
  //  .el-form-item__label{
  //    width: 40%!important;
  //  }
  //  .el-form-item__content{
  //    width: 60%!important;
  //    margin-left: 0!important;
  //    display: inline-block;
  //  }
  .error-date{
    position: relative;
    .el-input__inner{
      border-color: #E1233A;
    }
  }
  .padding6{
    .el-input__inner{
      padding-left: 6px!important;
    }
  }
  .crumbs {
    height: 20px;
    padding: 10px 0;
    display: none;
  }

  .upgradee {
    width: 100%;
    height: auto;
    line-height: 5mm;
    text-align: center;
    margin: 5mm 0
  }
  .upgrade-content {
    margin-left: 24px;
    line-height: 24px;
    color: #606266;
  }
  .el-notification {
    .el-notification__content {
      word-break: break-all;
    }
  }
  .newVersionNotificationClass {
    .el-notification__icon {
      color: #3C6EF0 !important;
    }
    .el-notification__content {
      button {
        background-color: #3C6EF0 !important;
      }
    }
  }
  // 危险品popover
  .uncode-popover {
    color: rgb(248, 6, 6);
    font-weight: bold;
  }
  #app {
    .login-modal{
      width: 520px;
      /* height: 237px; */
      border-radius: 6px;
      .el-dialog__header{
      padding: 0 !important;
      border-bottom: none !important
    }
    .login-msg-title{
      display: flex;
      align-items: center;
      padding: 24px;
      img{
        width: 22px;
        height: 22px;
        margin-right: 16px;
      }
      .title{
        width: 209px;
        font-size: 18px;
        font-family: PingFangSC;
        font-weight: 500;
        color: #232930;
      }
      .el-dialog__headerbtn{
        top: 25px !important;
        font-size: 20px !important;
        .el-icon-close{
          font-size: 16px;
        }
      }
    }
    .el-dialog__body{
      padding: 0 !important;
      border-bottom: none !important;
    }
    .login-content{
      .loginMessageContentDesc1{
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: normal;
        color: rgba(0,0,0,.6);
        padding: 12px 64px 24px 64px;
      }
      .loginMessageContentDesc2{
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: normal;
        color: rgba(0,0,0,.85);
        font-weight: normal;
        padding: 0px 64px 24px 64px;
        img{
          width: 16px;
          height: 16px;
          margin-right: 9px;
          margin-top: -4px;
          vertical-align: middle;
        }
        .link {
            color: #4c7cff;
            cursor: pointer;
        }
      }
      .loginMessageContentDesc3{
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: normal;
        color: rgba(0,0,0,.85);
        font-weight: normal;
        padding: 0px 64px 24px 64px;
        img{
          width: 16px;
          height: 16px;
          margin-right: 9px;
          margin-top: -4px;
          vertical-align: middle;
        }
      }
    }
    }
  }
  .custom-toast {
    .el-message__content {
      color: #525765!important;
    }
  }
  .custom-cancel-button{
    background: #F6F6F8 !important;
    height: 36px !important;
    font-size: 16px !important;
    font-family: PingFang SC;
    font-weight: normal;
    color: rgba(82,87,101,1);
    &:hover{
      background: rgba(60,110,240,0.1) !important;
      color: rgba(60,110,240,1);
    }
  }
  .custom-confirm-button {
    height: 36px !important;
    font-size: 16px !important;
    font-family: PingFang SC;
    font-weight: normal;
    color: rgba(255,255,255,1);
  }
  /deep/.el-message-box__message{
    font-size: 16px;
  }

  .el-notification__content{
    width: 240px;
    span, p {
      word-break: break-all;
      text-align: left;
      font-size:20px !important;
      line-height:24px !important;
      font-weight: 600;
    }
  }
  .el-table__fixed-right-patch {
    background-color: #F5F5F6 !important;
  }
</style>
